export default "__VITE_ASSET__a5DeUQoa__"